import { env } from './env';

export { storageAdapter, setStorageAdapter } from './storage.adapter';
export {
  loaderAdapter,
  setLoaderAdapter,
  loadSharedComponent,
  removeSharedComponent,
  LOCAL_RENDERERS,
} from './sharedComponents.adapter';
export { storeTokens, getValidToken, authenticatedFetch } from './auth';
export { env } from './env';
export enum CONTEXT {
  PWA = 'pwa',
  WXT = 'wxt',
  EXT_PAGES = 'ext-pages',
}

export const getContext = () => {
  // @ts-ignore this has a type error outside of wxt
  if (typeof chrome !== 'undefined' && chrome?.runtime?.id !== undefined) {
    return CONTEXT.WXT;
  }

  const appContext = env('VITE_APP_CONTEXT');
  if (appContext === 'pwa') {
    return CONTEXT.PWA;
  }

  return CONTEXT.EXT_PAGES;
};
